/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
// Duplicitní hodnoty jsou záměrné: jde o test-ID selektory sdílené E2E testy, hodnoty nelze měnit.
export enum Cy_SablonyVytvoreni {
  stepper = 'sablony-vytvoreni-stepper',
  kx_dalsi = 'komplexnost-dalsi',

  // zakladni specifikace inputs
  zs_typOpravneni = 'zakladni-specifikace-typ-opravneni',
  zs_platnostOd = 'zakladni-specifikace-platnost-od',
  zs_nazev = 'zakladni-specifikace-nazev',
  zs_jePostupitelne = 'zakladni-specifikace-je-postupitelne',
  zs_sablonuLzeUplatnit = 'zakladni-specifikace-sablonu-lze-uplatnit',
  zs_definovatRoliZastupovaneho = 'zakladni-specifikace-definovat-roli-zastupovaneho',
  zs_definovatRoliZastupujiciho = 'zakladni-specifikace-definovat-roli-zastupujiciho',
  zs_roleZastupovaneho = 'zakladni-specifikace-role-zastupovaneho',
  zs_zastupovanehoLzeDefinovatNasobne = 'zakladni-specifikace-zastupovaneho-lze-definovat-nasobne',
  zs_roleZastupujiciho = 'zakladni-specifikace-role-zastupujiciho',
  zs_zastupujicihoLzeDefinovatNasobne = 'zakladni-specifikace-zastupujiciho-lze-definovat-nasobne',
  zs_popis = 'zakladni-specifikace-popis',
  zs_dobaDoArchivace = 'zakladni-specifikace-doba-do-archivace',
  zs_dobaDoArchivaceJednotka = 'zakladni-specifikace-doba-do-archivace-jednotka',
  zs_dobaArchivace = 'zakladni-specifikace-doba-archivace',
  zs_dalsi = 'zakladni-specifikace-dalsi',

  // zakladni specifikace - pridat roli dialog inputs
  zs_pr_dialog = 'pridat-roli-dialog',
  zs_pr_jeMozneZretezit = 'pridat-roli-je-mozne-zretezit',
  zs_pr_nazev = 'pridat-roli-nazev',
  zs_pr_popis = 'pridat-roli-popis',
  zs_pr_pridat = 'pridat-roli-pridat',
  zs_pr_zrusit = 'pridat-roli-zrusit',

  // omezeni na sluzby VS inputs
  os_pridatOmezeniSkupin = 'omezeni-na-sluzby-vs-pridat-omezeni-skupin',
  os_zpet = 'omezeni-na-sluzby-vs-zpet',
  os_dalsi = 'omezeni-na-sluzby-vs-dalsi',
  os_zobrazitUzivateli = 'omezeni-na-sluzby-vs-zobrazit-uzivateli',
  os_uzivatelMuze = 'omezeni-na-sluzby-vs-uzivatel-muze',
  os_popis = 'omezeni-na-sluzby-vs-popis',
  os_pridatSkupinuOmezeni = 'omezeni-na-sluzby-vs-pridat-skupinu-omezeni',
  os_volitelnostSkupiny = 'omezeni-na-sluzby-vs-volitelnost-skupiny',
  os_zobrazitPouzePopis = 'omezeni-na-sluzby-vs-zobrazit-pouze-popis',
  os_skupinaOmezeniPopis = 'omezeni-na-sluzby-vs-skupina-omezeni-popis',
  os_definovatParametry = 'omezeni-na-sluzby-vs-definovat-parametry',
  os_tabulka = 'omezeni-na-sluzby-vs-tabulka',
  os_tabulka_edit = 'omezeni-na-sluzby-vs-tabulka-edit',
  os_tabulka_odebrat = 'omezeni-na-sluzby-vs-tabulka-odebrat',

  // omezeni na sluzby VS - pridat omezeni skupin dialog inputs
  os_po_dialog = 'omezeni-skupin-dialog',
  os_po_nazev = 'omezeni-skupin-nazev',
  os_po_pridat = 'omezeni-skupin-pridat',
  os_po_zrusit = 'omezeni-skupin-zrusit',

  // omeseni na sluzby VS - přidat skupinu omezení dialog inputs
  os_ps_dialog = 'pridat-skupinu-omezeni-dialog',

  // omezeni na sluzby VS - definice parametrů dialog inputs
  os_dp_dialog = 'definice-parametru-dialog',
  os_dp_agenda = 'definice-parametru-agenda',
  os_dp_sluzba = 'definice-parametru-sluzba',
  os_dp_ukon = 'definice-parametru-ukon',
  os_dp_ovm = 'definice-parametru-ovm',
  os_dp_pridat = 'definice-parametru-pridat',
  os_dp_zrusit = 'definice-parametru-zrusit',

  // ostatní omezení
  oo_pridatSpecifickeOmezeni = 'ostatni-omezeni-pridat-specificke-omezeni',
  oo_lzeDefinovatVolnaOmezeni = 'ostatni-omezeni-lze-definovat-volna-omezeni',
  oo_lzeDefinovatLokalniOmezeni = 'ostatni-omezeni-lze-definovat-lokalni-omezeni',
  oo_zpet = 'ostatni-omezeni-zpet',
  oo_dalsi = 'ostatni-omezeni-dalsi',
  oo_dialog = 'ostatni-omezeni-dialog',
  oo_tabulka = 'ostatni-omezeni-tabulka',
  oo_tabulka_edit = 'ostatni-omezeni-tabulka-edit',
  oo_tabulka_odebrat = 'ostatni-omezeni-tabulka-odebrat',

  // ostatní omezení - další inputy
  oo_volitelnostOmezeni = 'ostatni-omezeni-volitelnost-omezeni',
  oo_zobrazitPouzePopisSkupiny = 'ostatni-omezeni-zobrazit-pouze-popis-skupiny',
  oo_popis = 'ostatni-omezeni-popis',
  oo_vybratZExistujicich = 'ostatni-omezeni-vybrat-z-existujicich',
  oo_definovatIdentifikator = 'ostatni-omezeni-definovat-identifikator',

  // ostatní omezení - vybrat z existujících dialog
  oo_vybrat_dialog = 'vybrat-z-existujicich-dialog',
  oo_vybrat_nazev = 'vybrat-z-existujicich-nazev',
  oo_vybrat_pridat = 'vybrat-z-existujicich-pridat',

  // ostatní omezení - definovat identifikátor dialog
  oo_definovat_dialog = 'definovat-identifikator-dialog',
  oo_definovat_nazev = 'definovat-identifikator-nazev',
  oo_definovat_popis = 'definovat-identifikator-popis',
  oo_definovat_pridat = 'definovat-identifikator-pridat',
  oo_definovat_ulozit = 'definovat-identifikator-ulozit',

  // objekty
  obj_vybratObjekt = 'objekty-vybrat-objekt', //
  obj_pridatNovyObjekt = 'objekty-pridat-novy-objekt', //
  obj_dalsi = 'objekty-dalsi', //

  // objekty - vybrat objekt dialog
  obj_vybrat_dialog = 'vybrat-objekt-dialog', //
  obj_vybrat_nazev = 'vybrat-objekt-nazev', //
  obj_vybrat_pridat = 'vybrat-objekt-pridat', //

  // objekty - pridat novy objekt dialog
  obj_pridat_dialog = 'pridat-novy-objekt-dialog', //
  obj_pridat_nazev = 'omezeni-skupin-nazev', // os_po_nazev
  obj_pridat_pridat = 'omezeni-skupin-pridat', // os_po_pridat

  // objekty - další inputy
  obj_volitelneUzivatelem = 'objekty-volitelne-uzivatelem', //
  obj_lzeDefinovatNasobne = 'objekty-lze-definovat-nasobne', //
  obj_popis = 'objekty-popis', //
  obj_urlExistenceObjektu = 'objekty-url-existence-objektu', //
  obj_urlExistenceSeznamu = 'objekty-url-existence-seznamu', //
  obj_vybratZExistujicich = 'objekty-vybrat-z-existujicich', //
  obj_definovatIdentifikator = 'objekty-definovat-identifikator', //
  obj_tabulka = 'objekty-tabulka', //

  // objekty - vybrat z existujících dialog
  obj_vybratZ_dialog = 'vybrat-z-existujicich-dialog', //
  // obj_vybratZ_nazev = 'vybrat-z-existujicich-nazev',
  obj_vybratZ_nazev = 'vybrat-objekt-nazev', //
  // obj_vybratZ_pridat = 'vybrat-z-existujicich-pridat',
  obj_vybratZ_pridat = 'vybrat-objekt-pridat', //

  // objekty - definovat identifikátor dialog
  obj_definovat_dialog = 'definovat-identifikator-dialog', //
  obj_definovat_volitelneUzivatelem = 'definovat-identifikator-volitelne-uzivatelem', //
  obj_definovat_nazev = 'definovat-identifikator-nazev', //
  obj_definovat_vazba = 'definovat-identifikator-vazba', //
  obj_definovat_popis = 'definovat-identifikator-popis', //
  obj_definovat_typ = 'definovat-identifikator-typ', //
  obj_definovat_format = 'definovat-identifikator-format', //
  obj_definovat_pridat = 'definovat-identifikator-pridat', //

  // editor
  ed_nazev = 'editor-nazev', //
  ed_pridatKonkretnihoEditora = 'editor-pridat-konkretniho-editora', //
  ed_tabulka = 'editor-tabulka', //
  ed_dalsi = 'editor-dalsi', //

  // editor - pridat konkretniho editora dialog
  ed_pridat_dialog = 'pridat-konkretniho-editora-dialog', //
  ed_pridat_vyberteUzivatele = 'pridat-konkretniho-editora-vyberte-uzivatele', //
  ed_pridat_pridat = 'pridat-konkretniho-editora-pridat', //

  // poskytovatel stanoviska
  ps_pridatTypStanoviska = 'poskytovatel-stanoviska-pridat-typ-stanoviska', //
  ps_dalsi = 'poskytovatel-stanoviska-dalsi', //

  // poskytovatel stanoviska - pridat typ stanoviska dialog
  ps_pridat_dialog = 'pridat-typ-stanoviska-dialog', //
  ps_pridat_nazev = 'omezeni-skupin-nazev', //
  ps_pridat_pridat = 'omezeni-skupin-pridat', //

  // poskytovatel stanoviska - další inputy
  ps_nazev = 'editor-nazev', // ed_nazev
  ps_pridatKonkretnihoPoskytovatele = 'editor-pridat-konkretniho-editora', // ed_pridatKonkretnihoEditora
  ps_tabulka = 'editor-tabulka', // ed_tabulka

  // poskytovatel stanoviska - pridat konkretniho poskytovatele dialog
  ps_pridatK_dialog = 'pridat-konkretniho-editora-dialog', // ed_pridat_dialog
  ps_pridatK_vyberteUzivatele = 'pridat-konkretniho-editora-vyberte-uzivatele', // ed_pridat_vyberteUzivatele
  ps_pridatK_pridat = 'pridat-konkretniho-editora-pridat', // ed_pridat_pridat

  // nahled + odeslani
  nh_ulozit_a_odeslat = 'nahled-ulozit-a-odeslat',
  nh_dialog_odeslat_accept = 'nahled-dialog-odeslat-accept',
  nh_dialog_odeslat_reject = 'nahled-dialog-odeslat-reject',
}

// readonly Cy_SablonyVytvoreni = Cy_SablonyVytvoreni;
// [attr.data-cy]="Cy_SablonyVytvoreni.title"
